import { useContext } from 'react'
import SelectedContext from 'store/select-context'

const useSelected = () => {
    const SelectedCtx = useContext(SelectedContext);
    return SelectedCtx
}

export default useSelected;